import SpellsFilterAdvancedFilterOption from './SpellsFilterAdvancedFilterOption';

export default SpellsFilterAdvancedFilterOption;
export { SpellsFilterAdvancedFilterOption };
